import { Component, input, model, output, signal } from '@angular/core';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { ButtonComponent, CardComponent } from '@legacy/common-ui-partials';

import { CookieSettingsRendering } from '../../../model';
import { CookieSettingsCategoryComponent } from '../cookie-settings-category/cookie-settings-category.component';

@Component({
  selector: 'wl-cookie-settings',
  templateUrl: './cookie-settings.component.html',
  standalone: true,
  imports: [
    CookieSettingsCategoryComponent,
    ButtonComponent,
    CardComponent,
    CommonUiFormsModule,
    CommonUiUtilityComponentsModule,
  ],
})
export class CookieSettingsComponent {
  readonly trackingCookiesChecked = model(false);
  readonly rendering = input.required<CookieSettingsRendering>();

  readonly selectedSettings = output<boolean>();

  readonly submittingSettings = signal(false);

  submitSettings() {
    this.selectedSettings.emit(this.trackingCookiesChecked());
    this.submittingSettings.set(true);
  }

  onToggle(event: Event) {
    const toggled = (event.target as any)?.['checked'] ?? (false as boolean);
    this.trackingCookiesChecked.set(toggled);
  }
}
